// extracted by mini-css-extract-plugin
export default {"user-check-icon":"TYZqa"};